<template>
  <div class="card card-profile">
    <img
      :src="slider.image_url"
      alt="Image placeholder"
      class="card-img-top"
    />
    <div class="card-body pt-0">
      <div class="text-left mt-4">
        <h5>{{slider.title}}</h5>
        <div class="h6 font-weight-300">{{slider.description}}</div>
      </div>
      <div class="d-flex flex-row bd-highlight align-items-center justify-content-end">
        <div class="bd-highlight">
          <button class="btn btn-link text-danger text-gradient px-3 m-0" @click="showAlert">
            <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
            Eliminar
          </button>
        </div>
        <div class="bd-highlight">
          <router-link
            :to="`/slider-card/${slider.id}`"
            class="btn btn-link text-dark px-3 m-0"
          >
            <i class="fas fa-pencil-alt text-dark me-2" aria-hidden="true"></i
            >Editar
          </router-link>
        </div>
        <div class="bd-highlight">
          <argon-switch id="rememberMe" name="Remember Me" :checked="slider.active" @change-switch="statusSlider($event)">
            Activar
          </argon-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonSwitch from "@/components/ArgonSwitch.vue";
export default {
  name: "sliders-table",
  components: {
    ArgonSwitch,
  },
  props:{
    slider: {
      type: Object,
      required: true
    }
  },
  methods:{
    deleteSlider() {
      this.plain
        .delete(`/sliders/${this.slider.id}`)
        .then(() => {
          this.$parent.deleteItemSlider(this.slider.id)
        })
        .catch((error) => {
          console.log("Error al eliminar SLIDER", error);
        });
    },
    statusSlider(active) {
      this.plain
        .patch(`/sliders/${this.slider.id}`, {slider:{title:this.slider.title, description:this.slider.description, active}})
        .then((response) => {
          this.$parent.changeStatusSlider(response.data)
        })
        .catch((error) => {
          console.log("Error al editar status SLIDERS", error);
        });
    },
    showAlert() {
      //deleteUser(user.id)
      this.$swal.fire({
        title: '¿Está seguro?',
        text: "¡No podrás revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteSlider();
          this.$swal.fire(
            '¡Eliminado!',
            'La Imagen ha sido eliminado.',
          )
        }
      })
    }
  }
};
</script>